module.exports = __webpack_public_path__ + "static/media/lighthouse.aa2201d7.svg";